/** Shell for the /partner/* console — mirrors AppLayout (TopBar + sticky
 * sidebar + content column). Rendered as a route Outlet layout. */
import { Outlet } from "react-router-dom";

import { ImpersonationBanner } from "./ImpersonationBanner";
import { PartnerSidebar } from "./PartnerSidebar";
import { PartnerTopBar } from "./PartnerTopBar";

export function PartnerLayout() {
  return (
    <div className="min-h-dvh">
      {/* Shows only while a super-admin is impersonating this partner —
          gives a persistent "viewing as" indicator + one-click exit so they
          don't navigate away and strand the impersonation overlay. */}
      <ImpersonationBanner />
      <PartnerTopBar />
      <div className="mx-auto w-full max-w-screen-2xl 2xl:max-w-[105rem] px-6 py-8 lg:grid lg:grid-cols-[14rem_1fr] lg:gap-10">
        <PartnerSidebar />
        <main className="min-w-0 max-w-5xl space-y-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}


/** Standard page header inside the partner console (matches AppLayout's
 * eyebrow / page-title / section-lead). */
export function PartnerPageHeader({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <header className="flex items-start justify-between gap-4">
      <div className="min-w-0 space-y-2">
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1 className="page-title">{title}</h1>
        {description && (
          <p className="section-lead text-sm sm:text-base">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
